import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const SHORTCUTS: Array<[string, string]> = [
  ["⌘K / Ctrl+K", "Command palette"],
  ["/", "Focus page search"],
  ["?", "Shortcuts dialog"],
  ["g then d", "Dashboard"],
  ["g then r", "Runs"],
  ["g then c", "Test catalog"],
  ["g then a", "Admin dashboard (admins)"],
  ["g then u", "Users (admins)"],
  ["n", "New run (testers)"],
  ["j / k", "Next / previous row in tables and timelines"],
  ["Enter", "Open selected row"],
  ["Esc", "Close overlay"],
  ["f", "Toggle Follow in timeline and log viewer"],
];

export function ShortcutList() {
  return (
    <dl className="grid grid-cols-[auto_1fr] gap-x-6 gap-y-2 text-sm">
      {SHORTCUTS.map(([k, d]) => (
        <div key={k} className="contents">
          <dt>
            <kbd className="rounded border bg-muted px-1.5 py-0.5 font-mono text-xs">{k}</kbd>
          </dt>
          <dd>{d}</dd>
        </div>
      ))}
    </dl>
  );
}

export function ShortcutsDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
          <DialogDescription>Shortcuts are off while you type in a field.</DialogDescription>
        </DialogHeader>
        <ShortcutList />
      </DialogContent>
    </Dialog>
  );
}
